import { stubTrue } from "lodash";

import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const AdSpend = {
    id: "AdSpend",
    properties: {
        component: "AdSpendDashboard",
        mobileWebComponent: "AdSpendDashboard",
        apiController: "AdSpend",
        family: "Website",
        state: "digitalsuite_website_search_overview",
        dashboard: "true",
        title: "dashboard.metrics.titles.ad.spend",
        hasWebSource: true,
        webSource: devicesTypes.DESKTOP,
    },
    widgets: {
        single: {
            defaultType: "AdSpendLineChart",
            AdSpendLineChart: {
                properties: {
                    options: {
                        showLegend: false,
                        desktopOnly: false,
                        dashboardSubtitleMarginBottom: 20,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
        },
        compare: {
            defaultType: "AdSpendLineChart",
            AdSpendLineChart: {
                properties: {
                    options: {
                        legendAlign: "left",
                        showLegend: true,
                        legendTop: -20,
                        dashboardSubtitleMarginBottom: 10,
                        newColorPalette: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
        },
    },
};

export const PaidSearchAds = {
    id: "PaidSearchAds",
    properties: {
        component: "WebsitePaidSearchAds",
        family: "Website",
        state: "paidsearch_website_ads",
        dashboard: "true",
        title: "dashboard.metrics.titles.search.ads",
        endpoint: "api/WebsitePaidSearchAds",
        hasWebSource: true,
        webSource: devicesTypes.DESKTOP,
        viewPermissions: { trafficSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE] },
        noCompare: true,
        defaultDuration: BasicDurations.LAST_MONTH,
        isHidden: stubTrue,
        isDeprecated: true,
        disableTitleLink: true,
    },
    widgets: {
        single: {
            defaultType: "PaidSearchAdsTable",
            PaidSearchAdsTable: {
                properties: {
                    options: {
                        showLegend: false,
                        desktopOnly: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                    showMoreButtonItems: 1,
                },
                filters: {},
            },
        },
    },
};

const searchAdsWidgets = {
    single: {
        defaultType: "SearchAdsTable",
        SearchAdsTable: {
            properties: {
                options: {
                    showLegend: false,
                    desktopOnly: false,
                    dashboardSubtitleMarginBottom: 15,
                },
                showMoreButtonItems: 1,
            },
            filters: {},
        },
    },
};

const searchAdsProperties = {
    dashboard: "true",
    hasWebSource: true,
    noCompare: true,
    webSource: devicesTypes.TOTAL,
    viewPermissions: { trafficSources: [devicesTypes.TOTAL, devicesTypes.DESKTOP, devicesTypes.MOBILE] },
    availabilityComponent: "DigitalSuiteAcquisition",
};

export const SearchAdsWebsite = {
    id: "SearchAdsWebsite",
    properties: {
        family: "Website",
        component: "KeywordAnalysisV2Organic",
        mobileWebComponent: "KeywordAnalysisV2Organic",
        state: "paidsearch_website_ads",
        title: "dashboard.metrics.titles.search.ads.website",
        ...searchAdsProperties,
    },
    widgets: searchAdsWidgets,
};

export const SearchAdsKeyword = {
    id: "SearchAdsKeyword",
    properties: {
        family: "Keyword",
        component: "KeywordAnalysisV2Organic",
        mobileWebComponent: "KeywordAnalysisV2Organic",
        state: "paidsearch_keywordAnalysis_serp_ads",
        title: "dashboard.metrics.titles.search.ads.keyword",
        domainsEndpoint: "api/SearchAds/Keyword/Domains",
        ...searchAdsProperties,
    },
    widgets: searchAdsWidgets,
};
